import { Component } from "@angular/core";
import { DatePipe } from "@angular/common";
import { MatDialogRef } from "@angular/material/dialog";
import { AppointmentsService } from "../appointments.service";
import { LanguageService } from "../language.service";

@Component({
  selector: "app-lead-form-dialog",
  templateUrl: "./lead-form-dialog.component.html",
  styleUrls: ["./lead-form-dialog.component.scss"],
  standalone: false,
})
export class LeadFormDialogComponent {
  hmoOptions = ["Clalit", "Macabi", "Leumit", "Meuhedet"];
  lead = { ID: "", First: "", Last: "", Mobile: "", Email: "", Birth: null as Date | null, Sex: "", HMO: "", Note: "" };
  error = "";
  saving = false;

  constructor(
    public dialogRef: MatDialogRef<LeadFormDialogComponent>,
    public languageService: LanguageService,
    private appointmentService: AppointmentsService,
    private datePipe: DatePipe
  ) {}

  save() {
    if (!this.lead.First || !this.lead.Last || !this.lead.Mobile) {
      this.error = "required";
      return;
    }
    this.error = "";
    this.saving = true;
    const body = { ...this.lead, Birth: this.lead.Birth ? this.datePipe.transform(this.lead.Birth, "yyyy-MM-dd") : null };
    this.appointmentService.createLead(body).subscribe({
      next: () => this.dialogRef.close(true),
      error: () => {
        this.saving = false;
        this.error = "error";
      },
    });
  }

  close() {
    this.dialogRef.close();
  }
}
